export default class OauthJwtService {
  axiosIns = null

  jwtConfig = null

  constructor(axiosIns, jwtConfig) {
    this.axiosIns = axiosIns;
    this.jwtConfig = jwtConfig;
  }

  // The OAuth endpoints live at the API root, not under /api/v1
  static rootUrl() {
    return (process.env.VUE_APP_SERVER_URL || '').replace(/\/api\/v1\/?$/, '')
  }

  // name, logo and website of the application asking for sign-in, for the sign-in screens
  client({ client_id, redirect_uri }) {
    return this.axiosIns.get(`${OauthJwtService.rootUrl()}/oauth/client`, { params: { client_id, redirect_uri } })
  }

  issueCode(payload) {
    return this.axiosIns.post(`${OauthJwtService.rootUrl()}/oauth/authorize/code`, payload)
  }
}
